import React from "react";
import i18next from "i18next";

const ReportCard = ({
  id,
  titleAr,
  titleEn,
  descriptionAr,
  icon,
  color,
  badge,
  onClick,
  index,
}) => {
  const isArabic = i18next.dir(i18next.language) === "rtl";

  return (
    <div
      onClick={onClick}
      className={`
                ${color}
                rounded-xl
                p-3
                cursor-pointer
                transition-all
                duration-300
                hover:shadow-lg
                hover:scale-102
                border-[2px]
                border-[#9F91CF]/30
                hover:border-[#9F91CF]
                flex
                gap-3
                h-full
                ${index === 8 ? " flex-row-reverse col-span-4 justify-between items-center " : "flex-col justify-between  "}

                
            `}
    >
      {/* Icon */}
      {index === 8 ? (
        <div className="flex flex-row-reverse justify-between items-center  w-full">
          <img src={icon} className="w-[70px]  my-2" alt="" />
          <div className="flex flex-col gap-2 items-center justify-between">
            {/* Title */}
            <div>
              <h3 className="text-lg font-bold text-[#261759] mb-1 text-center">
                {isArabic ? titleAr : titleEn}
              </h3>
              <p className="text-sm text-[#261759]/80 text-center">
                {isArabic ? titleEn : titleAr}
              </p>
            </div>

            {/* Description Badge */}
            <div
              className={`
              ${badge}
          rounded-full
          px-3
          py-1
          text-sm
          text-center
          font-medium
          `}
            >
              {descriptionAr}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex justify-center items-center flex-col">
            <img src={icon} className="w-[70px] mx-auto my-2" alt="" />

            <h3 className="text-lg font-bold text-[#261759] mb-1 text-center">
              {isArabic ? titleAr : titleEn}
            </h3>
            <p className="text-sm text-[#261759]/80 text-center">
              {isArabic ? titleEn : titleAr}
            </p>
          </div>

          {/* Description Badge */}
          <div
            className={`
            ${badge}
          rounded-full
          px-3
          py-1
          text-sm
          text-center
          font-medium
          `}
          >
            {descriptionAr}
          </div>
        </>
      )}
    </div>
  );
};

export default ReportCard;
